import { render, staticRenderFns } from "./OnlineServiceDetail.vue?vue&type=template&id=b7885dc2&scoped=true"
import script from "./OnlineServiceDetail.vue?vue&type=script&lang=js"
export * from "./OnlineServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./OnlineServiceDetail.vue?vue&type=style&index=0&id=b7885dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7885dc2",
  null
  
)

export default component.exports